import $ from 'jquery';

const mobileMenuTriggerInit = () => {
    const $trigger = $('.c-mobile-nav-trigger');
    const $mobileMenu = $('.mobile-nav');
    const activeClass = 'is-active';
    const bodyActiveClass = 'mobile-menu-is-active';

    const closeMobileMenu = () => {
        $trigger.removeClass(activeClass);
        $trigger.attr('aria-expanded', 'false');
        $mobileMenu.removeClass(activeClass);
        $('body').removeClass(bodyActiveClass);
    };

    const openMobileMenu = () => {
        $trigger.addClass(activeClass);
        $trigger.attr('aria-expanded', 'true');
        $mobileMenu.addClass(activeClass);
        $('body').addClass(bodyActiveClass);
    };

    if ($trigger.length) {
        const menuId = $mobileMenu.attr('id') || 'mobile-nav';
        $mobileMenu.attr('id', menuId);
        $trigger.attr({
            'aria-expanded': 'false',
            'aria-controls': menuId,
            'aria-label': 'Toggle navigation menu'
        });

        $trigger.on('click', function () {
            const isActive = $(this).hasClass(activeClass);
            if (isActive) {
                closeMobileMenu();
            } else {
                openMobileMenu();
            }
        });

        // Close menu when clicking the overlay (::before pseudo-element area)
        $('.s-mobile-header').on('click', e => {
            if ($(e.target).hasClass('s-mobile-header') && $('body').hasClass(bodyActiveClass)) {
                closeMobileMenu();
            }
        });

        /* this interferes with react buttons, and doesn't seem to do anything? Commented out in case it's required.
        $(document).on('click', e => {
            if ($('body').hasClass(bodyActiveClass)
                && !$(e.target).closest('.mobile-nav').length
                && !$(e.target).closest('.c-mobile-nav-trigger').length) {
                closeMobileMenu();
            }
        });
        */
    }
};

// doc ready
$(() => {
    mobileMenuTriggerInit();
});
